import { render, staticRenderFns } from "./logisaddexport.vue?vue&type=template&id=0505f4e5&scoped=true"
import script from "./logisaddexport.vue?vue&type=script&lang=js"
export * from "./logisaddexport.vue?vue&type=script&lang=js"
import style0 from "./logisaddexport.vue?vue&type=style&index=0&id=0505f4e5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0505f4e5",
  null
  
)

export default component.exports